export enum AggregationType {
  SUM = 'SUM',
  MIN = 'MIN',
  MAX = 'MAX',
  MID = 'MID',
  COUNT = 'COUNT',
}
